import clsx from 'clsx';

const container = (className) => clsx('flex flex-col', className);
const arrow = clsx('text-caption1');
const separator = clsx('border-b border-gray-200 border-solid');
const variants = {
    primary: {
        arrow,
        body: clsx('pt-2 font-normal text-gray-700 text-paragraph'),
        button: clsx('flex w-full items-center justify-between', 'text-left text-body font-bold', 'duration-500'),
        container: (className) => clsx(container(className), 'gap-2'),
        separator,
    },
    secondary: {
        arrow,
        body: 'pt-6',
        button: clsx('flex w-full items-center justify-between', 'text-left text-h3 font-bold', 'transition-colors duration-500', 'ms-1'),
        buttonContainer: 'mt-6 mb-8',
        container,
        separator,
    },
};

export { variants as default };
